import { __assign } from "tslib";
import { SENSITIVE_STRING, isa as __isa } from "@aws-sdk/smithy-client";
export var BufferingHints;
(function (BufferingHints) {
    BufferingHints.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BufferingHints.isa = function (o) { return __isa(o, "BufferingHints"); };
})(BufferingHints || (BufferingHints = {}));
export var CloudWatchLoggingOptions;
(function (CloudWatchLoggingOptions) {
    CloudWatchLoggingOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CloudWatchLoggingOptions.isa = function (o) { return __isa(o, "CloudWatchLoggingOptions"); };
})(CloudWatchLoggingOptions || (CloudWatchLoggingOptions = {}));
export var CompressionFormat;
(function (CompressionFormat) {
    CompressionFormat["GZIP"] = "GZIP";
    CompressionFormat["HADOOP_SNAPPY"] = "HADOOP_SNAPPY";
    CompressionFormat["SNAPPY"] = "Snappy";
    CompressionFormat["UNCOMPRESSED"] = "UNCOMPRESSED";
    CompressionFormat["ZIP"] = "ZIP";
})(CompressionFormat || (CompressionFormat = {}));
export var ConcurrentModificationException;
(function (ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ConcurrentModificationException.isa = function (o) { return __isa(o, "ConcurrentModificationException"); };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
export var ContentEncoding;
(function (ContentEncoding) {
    ContentEncoding["GZIP"] = "GZIP";
    ContentEncoding["NONE"] = "NONE";
})(ContentEncoding || (ContentEncoding = {}));
export var CopyCommand;
(function (CopyCommand) {
    CopyCommand.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CopyCommand.isa = function (o) { return __isa(o, "CopyCommand"); };
})(CopyCommand || (CopyCommand = {}));
export var CreateDeliveryStreamInput;
(function (CreateDeliveryStreamInput) {
    CreateDeliveryStreamInput.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.RedshiftDestinationConfiguration && {
        RedshiftDestinationConfiguration: RedshiftDestinationConfiguration.filterSensitiveLog(obj.RedshiftDestinationConfiguration),
    })), (obj.HttpEndpointDestinationConfiguration && {
        HttpEndpointDestinationConfiguration: HttpEndpointDestinationConfiguration.filterSensitiveLog(obj.HttpEndpointDestinationConfiguration),
    }))); };
    CreateDeliveryStreamInput.isa = function (o) { return __isa(o, "CreateDeliveryStreamInput"); };
})(CreateDeliveryStreamInput || (CreateDeliveryStreamInput = {}));
export var CreateDeliveryStreamOutput;
(function (CreateDeliveryStreamOutput) {
    CreateDeliveryStreamOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateDeliveryStreamOutput.isa = function (o) { return __isa(o, "CreateDeliveryStreamOutput"); };
})(CreateDeliveryStreamOutput || (CreateDeliveryStreamOutput = {}));
export var DataFormatConversionConfiguration;
(function (DataFormatConversionConfiguration) {
    DataFormatConversionConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DataFormatConversionConfiguration.isa = function (o) { return __isa(o, "DataFormatConversionConfiguration"); };
})(DataFormatConversionConfiguration || (DataFormatConversionConfiguration = {}));
export var DeleteDeliveryStreamInput;
(function (DeleteDeliveryStreamInput) {
    DeleteDeliveryStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteDeliveryStreamInput.isa = function (o) { return __isa(o, "DeleteDeliveryStreamInput"); };
})(DeleteDeliveryStreamInput || (DeleteDeliveryStreamInput = {}));
export var DeleteDeliveryStreamOutput;
(function (DeleteDeliveryStreamOutput) {
    DeleteDeliveryStreamOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteDeliveryStreamOutput.isa = function (o) { return __isa(o, "DeleteDeliveryStreamOutput"); };
})(DeleteDeliveryStreamOutput || (DeleteDeliveryStreamOutput = {}));
export var DeliveryStreamDescription;
(function (DeliveryStreamDescription) {
    DeliveryStreamDescription.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Destinations && {
        Destinations: obj.Destinations.map(function (item) { return DestinationDescription.filterSensitiveLog(item); }),
    }))); };
    DeliveryStreamDescription.isa = function (o) { return __isa(o, "DeliveryStreamDescription"); };
})(DeliveryStreamDescription || (DeliveryStreamDescription = {}));
export var DeliveryStreamEncryptionConfiguration;
(function (DeliveryStreamEncryptionConfiguration) {
    DeliveryStreamEncryptionConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeliveryStreamEncryptionConfiguration.isa = function (o) {
        return __isa(o, "DeliveryStreamEncryptionConfiguration");
    };
})(DeliveryStreamEncryptionConfiguration || (DeliveryStreamEncryptionConfiguration = {}));
export var DeliveryStreamEncryptionConfigurationInput;
(function (DeliveryStreamEncryptionConfigurationInput) {
    DeliveryStreamEncryptionConfigurationInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeliveryStreamEncryptionConfigurationInput.isa = function (o) {
        return __isa(o, "DeliveryStreamEncryptionConfigurationInput");
    };
})(DeliveryStreamEncryptionConfigurationInput || (DeliveryStreamEncryptionConfigurationInput = {}));
export var DeliveryStreamEncryptionStatus;
(function (DeliveryStreamEncryptionStatus) {
    DeliveryStreamEncryptionStatus["DISABLED"] = "DISABLED";
    DeliveryStreamEncryptionStatus["DISABLING"] = "DISABLING";
    DeliveryStreamEncryptionStatus["DISABLING_FAILED"] = "DISABLING_FAILED";
    DeliveryStreamEncryptionStatus["ENABLED"] = "ENABLED";
    DeliveryStreamEncryptionStatus["ENABLING"] = "ENABLING";
    DeliveryStreamEncryptionStatus["ENABLING_FAILED"] = "ENABLING_FAILED";
})(DeliveryStreamEncryptionStatus || (DeliveryStreamEncryptionStatus = {}));
export var DeliveryStreamFailureType;
(function (DeliveryStreamFailureType) {
    DeliveryStreamFailureType["CREATE_ENI_FAILED"] = "CREATE_ENI_FAILED";
    DeliveryStreamFailureType["CREATE_KMS_GRANT_FAILED"] = "CREATE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["DELETE_ENI_FAILED"] = "DELETE_ENI_FAILED";
    DeliveryStreamFailureType["DISABLED_KMS_KEY"] = "DISABLED_KMS_KEY";
    DeliveryStreamFailureType["ENI_ACCESS_DENIED"] = "ENI_ACCESS_DENIED";
    DeliveryStreamFailureType["INVALID_KMS_KEY"] = "INVALID_KMS_KEY";
    DeliveryStreamFailureType["KMS_ACCESS_DENIED"] = "KMS_ACCESS_DENIED";
    DeliveryStreamFailureType["KMS_KEY_NOT_FOUND"] = "KMS_KEY_NOT_FOUND";
    DeliveryStreamFailureType["KMS_OPT_IN_REQUIRED"] = "KMS_OPT_IN_REQUIRED";
    DeliveryStreamFailureType["RETIRE_KMS_GRANT_FAILED"] = "RETIRE_KMS_GRANT_FAILED";
    DeliveryStreamFailureType["SECURITY_GROUP_ACCESS_DENIED"] = "SECURITY_GROUP_ACCESS_DENIED";
    DeliveryStreamFailureType["SECURITY_GROUP_NOT_FOUND"] = "SECURITY_GROUP_NOT_FOUND";
    DeliveryStreamFailureType["SUBNET_ACCESS_DENIED"] = "SUBNET_ACCESS_DENIED";
    DeliveryStreamFailureType["SUBNET_NOT_FOUND"] = "SUBNET_NOT_FOUND";
    DeliveryStreamFailureType["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(DeliveryStreamFailureType || (DeliveryStreamFailureType = {}));
export var DeliveryStreamStatus;
(function (DeliveryStreamStatus) {
    DeliveryStreamStatus["ACTIVE"] = "ACTIVE";
    DeliveryStreamStatus["CREATING"] = "CREATING";
    DeliveryStreamStatus["CREATING_FAILED"] = "CREATING_FAILED";
    DeliveryStreamStatus["DELETING"] = "DELETING";
    DeliveryStreamStatus["DELETING_FAILED"] = "DELETING_FAILED";
})(DeliveryStreamStatus || (DeliveryStreamStatus = {}));
export var DescribeDeliveryStreamInput;
(function (DescribeDeliveryStreamInput) {
    DescribeDeliveryStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DescribeDeliveryStreamInput.isa = function (o) { return __isa(o, "DescribeDeliveryStreamInput"); };
})(DescribeDeliveryStreamInput || (DescribeDeliveryStreamInput = {}));
export var DescribeDeliveryStreamOutput;
(function (DescribeDeliveryStreamOutput) {
    DescribeDeliveryStreamOutput.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.DeliveryStreamDescription && {
        DeliveryStreamDescription: DeliveryStreamDescription.filterSensitiveLog(obj.DeliveryStreamDescription),
    }))); };
    DescribeDeliveryStreamOutput.isa = function (o) { return __isa(o, "DescribeDeliveryStreamOutput"); };
})(DescribeDeliveryStreamOutput || (DescribeDeliveryStreamOutput = {}));
export var Deserializer;
(function (Deserializer) {
    Deserializer.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Deserializer.isa = function (o) { return __isa(o, "Deserializer"); };
})(Deserializer || (Deserializer = {}));
export var DestinationDescription;
(function (DestinationDescription) {
    DestinationDescription.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.RedshiftDestinationDescription && {
        RedshiftDestinationDescription: RedshiftDestinationDescription.filterSensitiveLog(obj.RedshiftDestinationDescription),
    })), (obj.HttpEndpointDestinationDescription && {
        HttpEndpointDestinationDescription: HttpEndpointDestinationDescription.filterSensitiveLog(obj.HttpEndpointDestinationDescription),
    }))); };
    DestinationDescription.isa = function (o) { return __isa(o, "DestinationDescription"); };
})(DestinationDescription || (DestinationDescription = {}));
export var ElasticsearchBufferingHints;
(function (ElasticsearchBufferingHints) {
    ElasticsearchBufferingHints.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ElasticsearchBufferingHints.isa = function (o) { return __isa(o, "ElasticsearchBufferingHints"); };
})(ElasticsearchBufferingHints || (ElasticsearchBufferingHints = {}));
export var ElasticsearchDestinationConfiguration;
(function (ElasticsearchDestinationConfiguration) {
    ElasticsearchDestinationConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ElasticsearchDestinationConfiguration.isa = function (o) {
        return __isa(o, "ElasticsearchDestinationConfiguration");
    };
})(ElasticsearchDestinationConfiguration || (ElasticsearchDestinationConfiguration = {}));
export var ElasticsearchDestinationDescription;
(function (ElasticsearchDestinationDescription) {
    ElasticsearchDestinationDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ElasticsearchDestinationDescription.isa = function (o) {
        return __isa(o, "ElasticsearchDestinationDescription");
    };
})(ElasticsearchDestinationDescription || (ElasticsearchDestinationDescription = {}));
export var ElasticsearchDestinationUpdate;
(function (ElasticsearchDestinationUpdate) {
    ElasticsearchDestinationUpdate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ElasticsearchDestinationUpdate.isa = function (o) { return __isa(o, "ElasticsearchDestinationUpdate"); };
})(ElasticsearchDestinationUpdate || (ElasticsearchDestinationUpdate = {}));
export var ElasticsearchRetryOptions;
(function (ElasticsearchRetryOptions) {
    ElasticsearchRetryOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ElasticsearchRetryOptions.isa = function (o) { return __isa(o, "ElasticsearchRetryOptions"); };
})(ElasticsearchRetryOptions || (ElasticsearchRetryOptions = {}));
export var EncryptionConfiguration;
(function (EncryptionConfiguration) {
    EncryptionConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EncryptionConfiguration.isa = function (o) { return __isa(o, "EncryptionConfiguration"); };
})(EncryptionConfiguration || (EncryptionConfiguration = {}));
export var ExtendedS3DestinationConfiguration;
(function (ExtendedS3DestinationConfiguration) {
    ExtendedS3DestinationConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExtendedS3DestinationConfiguration.isa = function (o) {
        return __isa(o, "ExtendedS3DestinationConfiguration");
    };
})(ExtendedS3DestinationConfiguration || (ExtendedS3DestinationConfiguration = {}));
export var ExtendedS3DestinationDescription;
(function (ExtendedS3DestinationDescription) {
    ExtendedS3DestinationDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExtendedS3DestinationDescription.isa = function (o) { return __isa(o, "ExtendedS3DestinationDescription"); };
})(ExtendedS3DestinationDescription || (ExtendedS3DestinationDescription = {}));
export var ExtendedS3DestinationUpdate;
(function (ExtendedS3DestinationUpdate) {
    ExtendedS3DestinationUpdate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExtendedS3DestinationUpdate.isa = function (o) { return __isa(o, "ExtendedS3DestinationUpdate"); };
})(ExtendedS3DestinationUpdate || (ExtendedS3DestinationUpdate = {}));
export var FailureDescription;
(function (FailureDescription) {
    FailureDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    FailureDescription.isa = function (o) { return __isa(o, "FailureDescription"); };
})(FailureDescription || (FailureDescription = {}));
export var HiveJsonSerDe;
(function (HiveJsonSerDe) {
    HiveJsonSerDe.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    HiveJsonSerDe.isa = function (o) { return __isa(o, "HiveJsonSerDe"); };
})(HiveJsonSerDe || (HiveJsonSerDe = {}));
export var HttpEndpointBufferingHints;
(function (HttpEndpointBufferingHints) {
    HttpEndpointBufferingHints.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    HttpEndpointBufferingHints.isa = function (o) { return __isa(o, "HttpEndpointBufferingHints"); };
})(HttpEndpointBufferingHints || (HttpEndpointBufferingHints = {}));
export var HttpEndpointCommonAttribute;
(function (HttpEndpointCommonAttribute) {
    HttpEndpointCommonAttribute.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.AttributeName && { AttributeName: SENSITIVE_STRING })), (obj.AttributeValue && { AttributeValue: SENSITIVE_STRING }))); };
    HttpEndpointCommonAttribute.isa = function (o) { return __isa(o, "HttpEndpointCommonAttribute"); };
})(HttpEndpointCommonAttribute || (HttpEndpointCommonAttribute = {}));
export var HttpEndpointConfiguration;
(function (HttpEndpointConfiguration) {
    HttpEndpointConfiguration.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.AccessKey && { AccessKey: SENSITIVE_STRING })), (obj.Url && { Url: SENSITIVE_STRING }))); };
    HttpEndpointConfiguration.isa = function (o) { return __isa(o, "HttpEndpointConfiguration"); };
})(HttpEndpointConfiguration || (HttpEndpointConfiguration = {}));
export var HttpEndpointDescription;
(function (HttpEndpointDescription) {
    HttpEndpointDescription.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Url && { Url: SENSITIVE_STRING }))); };
    HttpEndpointDescription.isa = function (o) { return __isa(o, "HttpEndpointDescription"); };
})(HttpEndpointDescription || (HttpEndpointDescription = {}));
export var HttpEndpointDestinationConfiguration;
(function (HttpEndpointDestinationConfiguration) {
    HttpEndpointDestinationConfiguration.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.EndpointConfiguration && {
        EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration),
    })), (obj.RequestConfiguration && {
        RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration),
    }))); };
    HttpEndpointDestinationConfiguration.isa = function (o) {
        return __isa(o, "HttpEndpointDestinationConfiguration");
    };
})(HttpEndpointDestinationConfiguration || (HttpEndpointDestinationConfiguration = {}));
export var HttpEndpointDestinationDescription;
(function (HttpEndpointDestinationDescription) {
    HttpEndpointDestinationDescription.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.RequestConfiguration && {
        RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration),
    })), (obj.EndpointConfiguration && {
        EndpointConfiguration: HttpEndpointDescription.filterSensitiveLog(obj.EndpointConfiguration),
    }))); };
    HttpEndpointDestinationDescription.isa = function (o) {
        return __isa(o, "HttpEndpointDestinationDescription");
    };
})(HttpEndpointDestinationDescription || (HttpEndpointDestinationDescription = {}));
export var HttpEndpointDestinationUpdate;
(function (HttpEndpointDestinationUpdate) {
    HttpEndpointDestinationUpdate.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.EndpointConfiguration && {
        EndpointConfiguration: HttpEndpointConfiguration.filterSensitiveLog(obj.EndpointConfiguration),
    })), (obj.RequestConfiguration && {
        RequestConfiguration: HttpEndpointRequestConfiguration.filterSensitiveLog(obj.RequestConfiguration),
    }))); };
    HttpEndpointDestinationUpdate.isa = function (o) { return __isa(o, "HttpEndpointDestinationUpdate"); };
})(HttpEndpointDestinationUpdate || (HttpEndpointDestinationUpdate = {}));
export var HttpEndpointRequestConfiguration;
(function (HttpEndpointRequestConfiguration) {
    HttpEndpointRequestConfiguration.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.CommonAttributes && {
        CommonAttributes: obj.CommonAttributes.map(function (item) { return HttpEndpointCommonAttribute.filterSensitiveLog(item); }),
    }))); };
    HttpEndpointRequestConfiguration.isa = function (o) { return __isa(o, "HttpEndpointRequestConfiguration"); };
})(HttpEndpointRequestConfiguration || (HttpEndpointRequestConfiguration = {}));
export var HttpEndpointRetryOptions;
(function (HttpEndpointRetryOptions) {
    HttpEndpointRetryOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    HttpEndpointRetryOptions.isa = function (o) { return __isa(o, "HttpEndpointRetryOptions"); };
})(HttpEndpointRetryOptions || (HttpEndpointRetryOptions = {}));
export var InputFormatConfiguration;
(function (InputFormatConfiguration) {
    InputFormatConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InputFormatConfiguration.isa = function (o) { return __isa(o, "InputFormatConfiguration"); };
})(InputFormatConfiguration || (InputFormatConfiguration = {}));
export var InvalidArgumentException;
(function (InvalidArgumentException) {
    InvalidArgumentException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidArgumentException.isa = function (o) { return __isa(o, "InvalidArgumentException"); };
})(InvalidArgumentException || (InvalidArgumentException = {}));
export var InvalidKMSResourceException;
(function (InvalidKMSResourceException) {
    InvalidKMSResourceException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InvalidKMSResourceException.isa = function (o) { return __isa(o, "InvalidKMSResourceException"); };
})(InvalidKMSResourceException || (InvalidKMSResourceException = {}));
export var KeyType;
(function (KeyType) {
    KeyType["AWS_OWNED_CMK"] = "AWS_OWNED_CMK";
    KeyType["CUSTOMER_MANAGED_CMK"] = "CUSTOMER_MANAGED_CMK";
})(KeyType || (KeyType = {}));
export var KinesisStreamSourceConfiguration;
(function (KinesisStreamSourceConfiguration) {
    KinesisStreamSourceConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KinesisStreamSourceConfiguration.isa = function (o) { return __isa(o, "KinesisStreamSourceConfiguration"); };
})(KinesisStreamSourceConfiguration || (KinesisStreamSourceConfiguration = {}));
export var KinesisStreamSourceDescription;
(function (KinesisStreamSourceDescription) {
    KinesisStreamSourceDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KinesisStreamSourceDescription.isa = function (o) { return __isa(o, "KinesisStreamSourceDescription"); };
})(KinesisStreamSourceDescription || (KinesisStreamSourceDescription = {}));
export var KMSEncryptionConfig;
(function (KMSEncryptionConfig) {
    KMSEncryptionConfig.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    KMSEncryptionConfig.isa = function (o) { return __isa(o, "KMSEncryptionConfig"); };
})(KMSEncryptionConfig || (KMSEncryptionConfig = {}));
export var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    LimitExceededException.isa = function (o) { return __isa(o, "LimitExceededException"); };
})(LimitExceededException || (LimitExceededException = {}));
export var ListDeliveryStreamsInput;
(function (ListDeliveryStreamsInput) {
    ListDeliveryStreamsInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListDeliveryStreamsInput.isa = function (o) { return __isa(o, "ListDeliveryStreamsInput"); };
})(ListDeliveryStreamsInput || (ListDeliveryStreamsInput = {}));
export var ListDeliveryStreamsOutput;
(function (ListDeliveryStreamsOutput) {
    ListDeliveryStreamsOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListDeliveryStreamsOutput.isa = function (o) { return __isa(o, "ListDeliveryStreamsOutput"); };
})(ListDeliveryStreamsOutput || (ListDeliveryStreamsOutput = {}));
export var ListTagsForDeliveryStreamInput;
(function (ListTagsForDeliveryStreamInput) {
    ListTagsForDeliveryStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForDeliveryStreamInput.isa = function (o) { return __isa(o, "ListTagsForDeliveryStreamInput"); };
})(ListTagsForDeliveryStreamInput || (ListTagsForDeliveryStreamInput = {}));
export var ListTagsForDeliveryStreamOutput;
(function (ListTagsForDeliveryStreamOutput) {
    ListTagsForDeliveryStreamOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForDeliveryStreamOutput.isa = function (o) { return __isa(o, "ListTagsForDeliveryStreamOutput"); };
})(ListTagsForDeliveryStreamOutput || (ListTagsForDeliveryStreamOutput = {}));
export var OpenXJsonSerDe;
(function (OpenXJsonSerDe) {
    OpenXJsonSerDe.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    OpenXJsonSerDe.isa = function (o) { return __isa(o, "OpenXJsonSerDe"); };
})(OpenXJsonSerDe || (OpenXJsonSerDe = {}));
export var OrcCompression;
(function (OrcCompression) {
    OrcCompression["NONE"] = "NONE";
    OrcCompression["SNAPPY"] = "SNAPPY";
    OrcCompression["ZLIB"] = "ZLIB";
})(OrcCompression || (OrcCompression = {}));
export var OrcFormatVersion;
(function (OrcFormatVersion) {
    OrcFormatVersion["V0_11"] = "V0_11";
    OrcFormatVersion["V0_12"] = "V0_12";
})(OrcFormatVersion || (OrcFormatVersion = {}));
export var OrcSerDe;
(function (OrcSerDe) {
    OrcSerDe.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    OrcSerDe.isa = function (o) { return __isa(o, "OrcSerDe"); };
})(OrcSerDe || (OrcSerDe = {}));
export var OutputFormatConfiguration;
(function (OutputFormatConfiguration) {
    OutputFormatConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    OutputFormatConfiguration.isa = function (o) { return __isa(o, "OutputFormatConfiguration"); };
})(OutputFormatConfiguration || (OutputFormatConfiguration = {}));
export var ParquetCompression;
(function (ParquetCompression) {
    ParquetCompression["GZIP"] = "GZIP";
    ParquetCompression["SNAPPY"] = "SNAPPY";
    ParquetCompression["UNCOMPRESSED"] = "UNCOMPRESSED";
})(ParquetCompression || (ParquetCompression = {}));
export var ParquetSerDe;
(function (ParquetSerDe) {
    ParquetSerDe.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ParquetSerDe.isa = function (o) { return __isa(o, "ParquetSerDe"); };
})(ParquetSerDe || (ParquetSerDe = {}));
export var ParquetWriterVersion;
(function (ParquetWriterVersion) {
    ParquetWriterVersion["V1"] = "V1";
    ParquetWriterVersion["V2"] = "V2";
})(ParquetWriterVersion || (ParquetWriterVersion = {}));
export var ProcessingConfiguration;
(function (ProcessingConfiguration) {
    ProcessingConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ProcessingConfiguration.isa = function (o) { return __isa(o, "ProcessingConfiguration"); };
})(ProcessingConfiguration || (ProcessingConfiguration = {}));
export var Processor;
(function (Processor) {
    Processor.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Processor.isa = function (o) { return __isa(o, "Processor"); };
})(Processor || (Processor = {}));
export var ProcessorParameter;
(function (ProcessorParameter) {
    ProcessorParameter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ProcessorParameter.isa = function (o) { return __isa(o, "ProcessorParameter"); };
})(ProcessorParameter || (ProcessorParameter = {}));
export var ProcessorParameterName;
(function (ProcessorParameterName) {
    ProcessorParameterName["BUFFER_INTERVAL_IN_SECONDS"] = "BufferIntervalInSeconds";
    ProcessorParameterName["BUFFER_SIZE_IN_MB"] = "BufferSizeInMBs";
    ProcessorParameterName["LAMBDA_ARN"] = "LambdaArn";
    ProcessorParameterName["LAMBDA_NUMBER_OF_RETRIES"] = "NumberOfRetries";
    ProcessorParameterName["ROLE_ARN"] = "RoleArn";
})(ProcessorParameterName || (ProcessorParameterName = {}));
export var PutRecordBatchInput;
(function (PutRecordBatchInput) {
    PutRecordBatchInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordBatchInput.isa = function (o) { return __isa(o, "PutRecordBatchInput"); };
})(PutRecordBatchInput || (PutRecordBatchInput = {}));
export var PutRecordBatchOutput;
(function (PutRecordBatchOutput) {
    PutRecordBatchOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordBatchOutput.isa = function (o) { return __isa(o, "PutRecordBatchOutput"); };
})(PutRecordBatchOutput || (PutRecordBatchOutput = {}));
export var PutRecordBatchResponseEntry;
(function (PutRecordBatchResponseEntry) {
    PutRecordBatchResponseEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordBatchResponseEntry.isa = function (o) { return __isa(o, "PutRecordBatchResponseEntry"); };
})(PutRecordBatchResponseEntry || (PutRecordBatchResponseEntry = {}));
export var PutRecordInput;
(function (PutRecordInput) {
    PutRecordInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordInput.isa = function (o) { return __isa(o, "PutRecordInput"); };
})(PutRecordInput || (PutRecordInput = {}));
export var PutRecordOutput;
(function (PutRecordOutput) {
    PutRecordOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutRecordOutput.isa = function (o) { return __isa(o, "PutRecordOutput"); };
})(PutRecordOutput || (PutRecordOutput = {}));
export var _Record;
(function (_Record) {
    _Record.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    _Record.isa = function (o) { return __isa(o, "Record"); };
})(_Record || (_Record = {}));
export var RedshiftDestinationConfiguration;
(function (RedshiftDestinationConfiguration) {
    RedshiftDestinationConfiguration.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Username && { Username: SENSITIVE_STRING })), (obj.Password && { Password: SENSITIVE_STRING }))); };
    RedshiftDestinationConfiguration.isa = function (o) { return __isa(o, "RedshiftDestinationConfiguration"); };
})(RedshiftDestinationConfiguration || (RedshiftDestinationConfiguration = {}));
export var RedshiftDestinationDescription;
(function (RedshiftDestinationDescription) {
    RedshiftDestinationDescription.filterSensitiveLog = function (obj) { return (__assign(__assign({}, obj), (obj.Username && { Username: SENSITIVE_STRING }))); };
    RedshiftDestinationDescription.isa = function (o) { return __isa(o, "RedshiftDestinationDescription"); };
})(RedshiftDestinationDescription || (RedshiftDestinationDescription = {}));
export var RedshiftDestinationUpdate;
(function (RedshiftDestinationUpdate) {
    RedshiftDestinationUpdate.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.Username && { Username: SENSITIVE_STRING })), (obj.Password && { Password: SENSITIVE_STRING }))); };
    RedshiftDestinationUpdate.isa = function (o) { return __isa(o, "RedshiftDestinationUpdate"); };
})(RedshiftDestinationUpdate || (RedshiftDestinationUpdate = {}));
export var RedshiftRetryOptions;
(function (RedshiftRetryOptions) {
    RedshiftRetryOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RedshiftRetryOptions.isa = function (o) { return __isa(o, "RedshiftRetryOptions"); };
})(RedshiftRetryOptions || (RedshiftRetryOptions = {}));
export var ResourceInUseException;
(function (ResourceInUseException) {
    ResourceInUseException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResourceInUseException.isa = function (o) { return __isa(o, "ResourceInUseException"); };
})(ResourceInUseException || (ResourceInUseException = {}));
export var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResourceNotFoundException.isa = function (o) { return __isa(o, "ResourceNotFoundException"); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
export var S3DestinationConfiguration;
(function (S3DestinationConfiguration) {
    S3DestinationConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    S3DestinationConfiguration.isa = function (o) { return __isa(o, "S3DestinationConfiguration"); };
})(S3DestinationConfiguration || (S3DestinationConfiguration = {}));
export var S3DestinationDescription;
(function (S3DestinationDescription) {
    S3DestinationDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    S3DestinationDescription.isa = function (o) { return __isa(o, "S3DestinationDescription"); };
})(S3DestinationDescription || (S3DestinationDescription = {}));
export var S3DestinationUpdate;
(function (S3DestinationUpdate) {
    S3DestinationUpdate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    S3DestinationUpdate.isa = function (o) { return __isa(o, "S3DestinationUpdate"); };
})(S3DestinationUpdate || (S3DestinationUpdate = {}));
export var SchemaConfiguration;
(function (SchemaConfiguration) {
    SchemaConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SchemaConfiguration.isa = function (o) { return __isa(o, "SchemaConfiguration"); };
})(SchemaConfiguration || (SchemaConfiguration = {}));
export var Serializer;
(function (Serializer) {
    Serializer.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Serializer.isa = function (o) { return __isa(o, "Serializer"); };
})(Serializer || (Serializer = {}));
export var ServiceUnavailableException;
(function (ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ServiceUnavailableException.isa = function (o) { return __isa(o, "ServiceUnavailableException"); };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
export var SourceDescription;
(function (SourceDescription) {
    SourceDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SourceDescription.isa = function (o) { return __isa(o, "SourceDescription"); };
})(SourceDescription || (SourceDescription = {}));
export var SplunkDestinationConfiguration;
(function (SplunkDestinationConfiguration) {
    SplunkDestinationConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SplunkDestinationConfiguration.isa = function (o) { return __isa(o, "SplunkDestinationConfiguration"); };
})(SplunkDestinationConfiguration || (SplunkDestinationConfiguration = {}));
export var SplunkDestinationDescription;
(function (SplunkDestinationDescription) {
    SplunkDestinationDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SplunkDestinationDescription.isa = function (o) { return __isa(o, "SplunkDestinationDescription"); };
})(SplunkDestinationDescription || (SplunkDestinationDescription = {}));
export var SplunkDestinationUpdate;
(function (SplunkDestinationUpdate) {
    SplunkDestinationUpdate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SplunkDestinationUpdate.isa = function (o) { return __isa(o, "SplunkDestinationUpdate"); };
})(SplunkDestinationUpdate || (SplunkDestinationUpdate = {}));
export var SplunkRetryOptions;
(function (SplunkRetryOptions) {
    SplunkRetryOptions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SplunkRetryOptions.isa = function (o) { return __isa(o, "SplunkRetryOptions"); };
})(SplunkRetryOptions || (SplunkRetryOptions = {}));
export var StartDeliveryStreamEncryptionInput;
(function (StartDeliveryStreamEncryptionInput) {
    StartDeliveryStreamEncryptionInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StartDeliveryStreamEncryptionInput.isa = function (o) {
        return __isa(o, "StartDeliveryStreamEncryptionInput");
    };
})(StartDeliveryStreamEncryptionInput || (StartDeliveryStreamEncryptionInput = {}));
export var StartDeliveryStreamEncryptionOutput;
(function (StartDeliveryStreamEncryptionOutput) {
    StartDeliveryStreamEncryptionOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StartDeliveryStreamEncryptionOutput.isa = function (o) {
        return __isa(o, "StartDeliveryStreamEncryptionOutput");
    };
})(StartDeliveryStreamEncryptionOutput || (StartDeliveryStreamEncryptionOutput = {}));
export var StopDeliveryStreamEncryptionInput;
(function (StopDeliveryStreamEncryptionInput) {
    StopDeliveryStreamEncryptionInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StopDeliveryStreamEncryptionInput.isa = function (o) { return __isa(o, "StopDeliveryStreamEncryptionInput"); };
})(StopDeliveryStreamEncryptionInput || (StopDeliveryStreamEncryptionInput = {}));
export var StopDeliveryStreamEncryptionOutput;
(function (StopDeliveryStreamEncryptionOutput) {
    StopDeliveryStreamEncryptionOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StopDeliveryStreamEncryptionOutput.isa = function (o) {
        return __isa(o, "StopDeliveryStreamEncryptionOutput");
    };
})(StopDeliveryStreamEncryptionOutput || (StopDeliveryStreamEncryptionOutput = {}));
export var Tag;
(function (Tag) {
    Tag.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Tag.isa = function (o) { return __isa(o, "Tag"); };
})(Tag || (Tag = {}));
export var TagDeliveryStreamInput;
(function (TagDeliveryStreamInput) {
    TagDeliveryStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TagDeliveryStreamInput.isa = function (o) { return __isa(o, "TagDeliveryStreamInput"); };
})(TagDeliveryStreamInput || (TagDeliveryStreamInput = {}));
export var TagDeliveryStreamOutput;
(function (TagDeliveryStreamOutput) {
    TagDeliveryStreamOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TagDeliveryStreamOutput.isa = function (o) { return __isa(o, "TagDeliveryStreamOutput"); };
})(TagDeliveryStreamOutput || (TagDeliveryStreamOutput = {}));
export var UntagDeliveryStreamInput;
(function (UntagDeliveryStreamInput) {
    UntagDeliveryStreamInput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UntagDeliveryStreamInput.isa = function (o) { return __isa(o, "UntagDeliveryStreamInput"); };
})(UntagDeliveryStreamInput || (UntagDeliveryStreamInput = {}));
export var UntagDeliveryStreamOutput;
(function (UntagDeliveryStreamOutput) {
    UntagDeliveryStreamOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UntagDeliveryStreamOutput.isa = function (o) { return __isa(o, "UntagDeliveryStreamOutput"); };
})(UntagDeliveryStreamOutput || (UntagDeliveryStreamOutput = {}));
export var UpdateDestinationInput;
(function (UpdateDestinationInput) {
    UpdateDestinationInput.filterSensitiveLog = function (obj) { return (__assign(__assign(__assign({}, obj), (obj.HttpEndpointDestinationUpdate && {
        HttpEndpointDestinationUpdate: HttpEndpointDestinationUpdate.filterSensitiveLog(obj.HttpEndpointDestinationUpdate),
    })), (obj.RedshiftDestinationUpdate && {
        RedshiftDestinationUpdate: RedshiftDestinationUpdate.filterSensitiveLog(obj.RedshiftDestinationUpdate),
    }))); };
    UpdateDestinationInput.isa = function (o) { return __isa(o, "UpdateDestinationInput"); };
})(UpdateDestinationInput || (UpdateDestinationInput = {}));
export var UpdateDestinationOutput;
(function (UpdateDestinationOutput) {
    UpdateDestinationOutput.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateDestinationOutput.isa = function (o) { return __isa(o, "UpdateDestinationOutput"); };
})(UpdateDestinationOutput || (UpdateDestinationOutput = {}));
export var VpcConfiguration;
(function (VpcConfiguration) {
    VpcConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VpcConfiguration.isa = function (o) { return __isa(o, "VpcConfiguration"); };
})(VpcConfiguration || (VpcConfiguration = {}));
export var VpcConfigurationDescription;
(function (VpcConfigurationDescription) {
    VpcConfigurationDescription.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VpcConfigurationDescription.isa = function (o) { return __isa(o, "VpcConfigurationDescription"); };
})(VpcConfigurationDescription || (VpcConfigurationDescription = {}));
//# sourceMappingURL=index.js.map